import React from 'react'

function Header() {
    return (
        <div className="header">
            My Sticker Database
        </div>
    )
}

export default Header
